export const DECISION_TREE_MIN_ZOOM = 0.1;
export const DECISION_TREE_MAX_ZOOM = 1.5;
export const DECISION_TREE_ZOOM_STEP = 0.1;

export function clampDecisionTreeZoom(zoom: number): number {
  return Math.min(DECISION_TREE_MAX_ZOOM, Math.max(DECISION_TREE_MIN_ZOOM, zoom));
}

export function stepDecisionTreeZoom(zoom: number, direction: -1 | 1): number {
  return clampDecisionTreeZoom(Math.round((zoom + direction * DECISION_TREE_ZOOM_STEP) * 10) / 10);
}

export function fitDecisionTreeZoom(
  viewportWidth: number,
  viewportHeight: number,
  contentWidth: number,
  contentHeight: number,
  padding = 48,
): number {
  if (viewportWidth <= 0 || viewportHeight <= 0 || contentWidth <= 0 || contentHeight <= 0) {
    return 1;
  }
  const availableWidth = Math.max(1, viewportWidth - padding);
  const availableHeight = Math.max(1, viewportHeight - padding);
  return clampDecisionTreeZoom(
    Math.min(1, availableWidth / contentWidth, availableHeight / contentHeight),
  );
}
